<template src="./index.html">
</template>
<script>
import {getdata} from "./data.js"
import {queryExportIncomeDifference, saveExportIncomeDifference} from "../../../../api/ckywqk"
import { number } from "echarts/lib/export.js";

export default {
  props: {
    exportIncomeDifferenceDiag: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }

  },
  components: {
  },
  data: function () {
    return {
      headData: getdata().headData,
      tableData: getdata().tableData,
    }
  },
  watch: {
    exportIncomeDifferenceDiag: function (indexVal, oldVal) {
      if (indexVal) {
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.clearValidate()
          }
          if (this.$refs.taxform) {
            this.$refs.taxform.clearValidate()
          }
        })
      }
    },
    params: function (indexVal, oldVal) {
      if (indexVal) {
      }
    },
  },
  created() {
    if (this.params.sbbm === "qysdsA") {
      let params = {
        reportId: this.params.id
      };
      queryExportIncomeDifference(params).then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  },
  mounted() {
  },
  methods: {
    closediag(e) {
      this.$emit("closediag", '')
    },
    confirm() {
      let params = {
        reportId: this.params.id,
        detailDto: this.tableData
      };
      saveExportIncomeDifference(params).then((res) => {
        if (res.data.code === 1) {
          this.$message.success(res.data.msg);
          this.$emit("confirm", '')
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    inputblur(obj) {
      let total = 0.0;
      for(let i=0; i < this.tableData.cyyyList.length; i ++) {
        let forObj = this.tableData.cyyyList[i];
        if(forObj.cyyy != '合计') {
          total = parseFloat(total) + parseFloat(this.toFixed(Number(forObj.cyje), 2));
        }
      }
      for(let i=0; i < this.tableData.cyyyList.length; i ++) {
        let forObj = this.tableData.cyyyList[i];
        if(forObj.cyyy == '合计') {
          forObj.cyje = total;
          return;
        }  
      }
    }
  }
};
</script>


<style scoped lang="less">
@import url("./index.less");
</style>
